<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header full-height-page-wrapper">
          <PageHeader page-title="Work schedule">
            <template #buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'info' : 'secondary'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview"> tune </span>
                Filters
              </b-button>
            </template>
          </PageHeader>
          <Filters
            v-if="$can('read_all-booking_view')"
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="filters"
            :isLoading="loading && isInitialDataLoaded"
            showClearCache
            @submit="drawTableByFilters"
            @clearCache="clearCache()"
          />

          <div v-if="loading && !isInitialDataLoaded" class="content-loading-wrapper">
            <Preloader class="centered-preloader" />
          </div>

          <div v-else class="full-height-content">
            <fullscreen
              v-if="isInitialDataLoaded && !showNoData && table.users && Object.keys(getUsers).length > 0 && $can('read_own-booking_view')"
              background="#F3F5F7"
              class="table-fullscreen"
              ref="fullscreen"
              @change="fullScreenChange"
            >
            <div
              :class="{
                'table-fullscreen-container': fullscreen,
                'loading-data': loading && isInitialDataLoaded
              }"
              class="table__theme-default"
            >
              <div class="table-controls">
                <div class="table-controls-left">
                  <multiselect
                    style="width: 160px"
                    v-model="tabs.currentTabs"
                    :options="tabs.tabsList"
                    track-by="name"
                    label="display_name"
                    :showLabels="false"
                    multiple
                    allow-empty
                    ref="multiselect"
                  >
                    <template slot="option" slot-scope="props">
                      <div
                        class="option__desc"
                        @click.stop="selectRole(props.option, props)"
                      >
                        {{ props.option.display_name }}
                      </div>
                    </template>
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span
                        class="multiselect__single"
                        v-if="values.length > 1 && !isOpen"
                      >
                        {{ values.length }}/{{ tabs.tabsList.length }}
                      </span>
                      <span
                        class="multiselect__single"
                        v-if="values.length === 1 && !isOpen"
                      >
                        {{ values[0].display_name }}
                      </span>
                    </template>
                    <template slot="tag"><i></i></template>
                  </multiselect>
                  <!-- <b-form-select v-model="showBooking" :options="bookingSelect" size="sm" class="mt-3"></b-form-select> -->
                  <div class="ml-3 booking-input">
                    <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="showBooking ? showBooking.label : null">
                      <multiselect
                        v-model="showBooking"
                        :options="bookingSelect"
                        :placeholder="'Select'"
                        :track-by="'value'"
                        :label="'label'"
                        :allow-empty="false"
                        :showLabels="false"
                        :class="{ 'multiselect__single-line': true }"
                      />
                    </div>
                  </div>
                  <div class="ml-3 big-input">
                    <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="employmentType ? employmentType.label : null">
                      <multiselect
                        v-model="employmentType"
                        :options="employmentSelect"
                        :placeholder="'Select'"
                        :track-by="'value'"
                        :label="'label'"
                        :allow-empty="false"
                        :showLabels="false"
                        :class="{ 'multiselect__single-line': true }"
                      />
                    </div>
                  </div>
                  <div class="ml-3 big-input">
                    <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="paymentType ? paymentType.label : null">
                      <multiselect
                        v-model="paymentType"
                        :options="paymentSelect"
                        :placeholder="'Select'"
                        :track-by="'value'"
                        :label="'label'"
                        :allow-empty="false"
                        :showLabels="false"
                        :class="{ 'multiselect__single-line': true }"
                      />
                    </div>
                  </div>
                  <div class="ml-3">
                    <multiselect
                      style="width: 150px"
                      v-model="getMonth"
                      :options="getAllMonth"
                      :track-by="'value'"
                      :label="'value'"
                      :showLabels="false"
                      :allow-empty="false"
                      multiple
                      ref="months"
                    >
                      <template slot="option" slot-scope="props">
                        <div
                          class="option__desc"
                          @click.stop="selectMonths(props.option, props)"
                        >
                          {{ props.option.value }}
                        </div>
                      </template>
                      <template
                        slot="selection"
                        slot-scope="{ values, isOpen }"
                      >
                        <span
                          class="multiselect__single"
                          v-if="values.length > 1 && !isOpen"
                        >
                          {{ values.length }}/{{ getAllMonth.length }}
                        </span>
                        <span
                          class="multiselect__single"
                          v-if="values.length === 1 && !isOpen"
                        >
                          {{ values[0].value }}
                        </span>
                      </template>
                      <template slot="tag"><i></i></template>
                    </multiselect>
                  </div>
                  <div class="ml-3 table-control">
                    <b-button
                      class="button btn-icon button-checkbox_sm switch"
                      @click="showRemote = !showRemote"
                    >
                      <b-form-checkbox
                        size="sm"
                        switch
                        v-model="showRemote"
                        class="switch"
                        id="tet"
                        @change="showRemote = !showRemote"
                      >
                      </b-form-checkbox>
                    </b-button>
                    <div
                      @click="showRemote = !showRemote"
                      class="table-control__text"
                    >
                      <span v-if="showRemote">Show</span>
                      <span v-else>Hide</span> remote
                    </div>
                  </div>
                </div>
                <div class="table-controls-right">
                  <!-- <div class="table-info-label mr-1">Office</div>
                  <div class="table-info-label bg-stripes mr-2">Remote</div> -->
                  <b-button
                    class="button btn-icon"
                    variant="outline-info"
                    @click="toggleFullscreen"
                  >
                    <span class="material-icons"> fullscreen </span>
                  </b-button>
                </div>
              </div>
              <div class="table-container">
                <div class="booking-table-wrapper">
                  <div class="table-scroll" v-dragscroll>
                    <table class="table">
                      <thead>
                        <tr>
                          <span class="fixed-td">
                            <th scope="col" class="fixed-number">#</th>
                            <th
                              scope="col"
                              class="fixed-user"
                              style="padding-left: 0"
                            >
                              User
                            </th>
                            <th
                              scope="col"
                              class="fixed-actions"
                              v-if="$can(permissions.ReadAllComments)"
                            >
                              Actions
                            </th>
                          </span>
                          <th
                            scope="col"
                            v-for="(item, key, index) in getDates"
                            :key="item.date"
                            class="scheduleTimeLine"
                            :class="{
                              'day-off': item.dayOff,
                              'first-date-in-head': index === 0,
                            }"
                          >
                            <span class="d-inline-block">
                              {{
                                $moment(item.date, "YYYY-MM-DD").format("MM.DD")
                              }}
                            </span>
                            / {{ new Date(item.date).toString().split(" ")[0] }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(user, jira_user_name, user_index) in getUsers"
                        >
                          <tr :key="user.id">
                            <span class="fixed-td">
                              <td scope="col" class="fixed-number">
                                {{ user_index + 1 }}
                              </td>
                              <td
                                scope="col"
                                class="fixed-user"
                                v-b-tooltip.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
                                :title="createUserTooltip(user)"
                              >
                                <TableUserItem
                                  :user="user"
                                  :number="user_index"
                                  :user-tooltip="false"
                                />
                              </td>
                              <td
                                scope="col"
                                class="fixed-comment"
                                v-if="$can(permissions.ReadAllComments)"
                              >
                                <TextEditor
                                  :entity-type="
                                    commentEntityTypes.WorkScheduleItem
                                  "
                                  data-already-loaded
                                  :entity-id="user.id"
                                />
                              </td>
                            </span>
                            <td
                              cellspacing="0"
                              scope="col"
                              v-for="(item, date) in getDates"
                              :key="`cell${date}`"
                              :class="{ 'day-off': item.dayOff }"
                            >
                              <div v-if="item.dayOff" class="booking-day-off">
                                Day off
                              </div>
                              <div
                                class="day__add"
                                v-else-if="
                                  !table.workItems[date][jira_user_name]
                                    .items &&
                                  $can('create-booking_management') &&
                                  !['v', 'nv', 's', 'ns'].includes(
                                    table.workItems[date][jira_user_name]
                                      .working_day_type
                                  ) &&
                                  $can('create-booking_view')
                                "
                              >
                                <a
                                  variant="primary"
                                  @click.prevent.stop="
                                    addBooking({ user, date: date })
                                  "
                                  class="day__add-link"
                                  :class="{
                                    'bg-stripes': ['rx'].includes(
                                      table.workItems[date][jira_user_name]
                                        .working_day_type
                                    ),
                                    'full-time-team-members':
                                      user.payment_type === 'monthly' &&
                                      user.employment_type.type ===
                                        'team_member',
                                  }"
                                >
                                </a>
                              </div>
                              <span
                                v-if="
                                  !item.dayOff &&
                                  ['v', 'nv', 's', 'ns'].includes(
                                    table.workItems[date][jira_user_name]
                                      .working_day_type
                                  )
                                "
                                class="booking-line"
                                :class="
                                  'booking-line_dayoff booking-line-' +
                                  table.workItems[date][jira_user_name]
                                    .working_day_type
                                "
                                :style="{
                                  width: setWorkingItemDuration(undefined, 10),
                                }"
                              >
                                {{
                                  ["v", "nv"].includes(
                                    table.workItems[date][jira_user_name]
                                      .working_day_type
                                  )
                                    ? "Vacation"
                                    : "Sick day"
                                }}
                              </span>

                              <template v-else-if="!item.dayOff">
                                <div
                                  class="booking-works-event"
                                  :class="{
                                    'bg-stripes': ['rx'].includes(
                                      table.workItems[date][jira_user_name]
                                        .working_day_type
                                    ),
                                  }"
                                  @click.prevent.stop="
                                    addBooking({ user, date: date })
                                  "
                                  v-if="
                                    table.workItems[date][jira_user_name].items
                                  "
                                >
                                  <template
                                    v-if="showRemoteTasks(date, jira_user_name)"
                                  >
                                    <template
                                      v-for="(workItem, index) in table
                                        .workItems[date][jira_user_name].items"
                                    >
                                      <a
                                        :key="index"
                                        v-if="
                                          workItem.type === 'booking_hourly' ||
                                          workItem.type === 'booking_period'
                                        "
                                        @click.stop="
                                          editModalOpen({
                                            user,
                                            start_date:
                                              workItem.item
                                                .booking_group_start_date,
                                            end_date:
                                              workItem.item
                                                .booking_group_end_date,
                                            hours_per_day:
                                              workItem.duration / 3600,
                                            booking_hours:
                                              workItem.item.booking_hours,
                                            booking_type_id:
                                              workItem.item.booking_type_id,
                                            project_id:
                                              workItem.item.project_id,
                                            comment: workItem.item.comment,
                                            id: workItem.item.booking_group_id,
                                          })
                                        "
                                        class="booking-line booking-line_booking"
                                        :style="getBookingStyle(workItem)"
                                        v-b-tooltip.html
                                        :title="
                                          createTaskTooltip(workItem.title)
                                        "
                                      >
                                        {{ workItem.title }}
                                      </a>
                                      <a
                                        v-else-if="workItem.type === 'backlog'"
                                        :key="index"
                                        @click.stop
                                        :href="
                                          'https://giraffesoftware.atlassian.net/browse/' +
                                          workItem.item.key
                                        "
                                        target="_blank"
                                        :style="getBacklogStyle(workItem)"
                                        class="booking-line booking-line_backlog"
                                        v-b-tooltip.html
                                        :title="
                                          createTaskTooltip(workItem.title)
                                        "
                                      >
                                        {{ workItem.title }}
                                      </a>
                                    </template>
                                  </template>
                                </div>
                              </template>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <b-modal static size="lg" hide-footer ref="bookingModal" centered  :modal-class="formLoading ? 'loading' : ''">
              <template v-slot:modal-header="{ cancel }">
                <h5 class="modal-title">
                  {{ isEdit ? "Edit booking" : "Create booking" }}
                </h5>
                <button
                  type="button"
                  aria-label="Close"
                  class="close"
                  @click.prevent="cancel"
                >
                  <span class="material-icons"> close </span>
                </button>
              </template>
              <BookingForm
                v-if="dialog"
                :projects="projects"
                :users="users"
                :unitManagers="unitManagers"
                :dataProps="editedItem"
                :edit="isEdit"
                :show-preloader="true"
                :modal="true"
                @submit="submit"
                @remove="removeTask"
              />
            </b-modal>
            </fullscreen>

            <EmptyStateNoResults
              v-else-if="isInitialDataLoaded && (showNoData || !table.users || Object.keys(getUsers).length === 0)"
              title="No work schedule yet"
              description="No data to display. Entries from all employees will appear here once recorded."
              customIcon="view_timeline"
              customIconClasses="material-symbols-outlined empty-state__icon"
              :withoutButton="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Moment from 'moment'
// import { extendMoment } from 'moment-range'

import { commentEntityTypes } from '@mocks/comment-entity-types'
import BookingMixin from '../mixins/booking'
import BookingForm from '../components/forms/BookingForm'
import { mapGetters, mapActions } from 'vuex'
import { dragscroll } from 'vue-dragscroll'
import Filters from '@components/Filter/Filter'
import TextEditor from '@components/TextEditor'
import TableUserItem from '@components/tables/TableUserItem'
import { uniqBy } from 'lodash'
import { permissions } from '@mocks/permissions'
import PageHeader from '@components/PageHeader.vue'
import Preloader from '@components/Preloader'
import EmptyStateNoResults from '@components/EmptyStateNoResults.vue'

// const moment = extendMoment(Moment)
const constants = {
  tdWidthWithoutBorder: 150, // (td width - border width - 2px)
  tdWidth: 150,
  tdHeight: 40,
  fullDayHours: 8,
  allRoles: { name: 'all', display_name: 'All' },
  allMonths: [{ value: 'All months' }]
}

export default {
  name: 'BookingView',
  data () {
    return {
      permissions,
      dialog: false,
      isShowFilter: true,
      isAllOptionsFilterSet: false,
      isBookingDataLoaded: false,
      filters: {
        projects: {
          type: 'multiselect',
          name: 'projects',
          label: 'Select project',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        users: {
          type: 'multiselect',
          name: 'users',
          label: 'Select user',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        unitManagers: {
          type: 'multiselect',
          name: 'unitManagers',
          label: 'Select unit managers',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        projectStatus: {
          type: 'select',
          name: 'project_status',
          label: 'Select project status',
          valueField: null,
          selectLabel: null,
          options: [],
          value: '',
          class: 'col-md-3'
        }
      },
      bookingSelect: [
        { value: 'all', label: 'All bookings' },
        { value: 'with-booking', label: 'Has booking' },
        { value: 'no-booking', label: 'No booking' }
      ],
      employmentSelect: [
        { value: 'all', label: 'All employment types' },
        { value: 'team_member', label: 'Team member' },
        { value: 'independent', label: 'Independent' },
        { value: 'partner', label: 'Partner' }
      ],
      paymentSelect: [
        { value: 'all', label: 'All payment types' },
        { value: 'monthly', label: 'Full-time' },
        { value: 'hourly', label: 'Part-time' }
      ],
      selectedFilters: {},
      loading: true,
      formLoading: false,
      editedItem: {},
      showNoData: false,
      isEdit: false,
      nowDate: '',
      commentEditorOptions: {
        entity_type: commentEntityTypes.WorkScheduleItem,
        data_already_loaded: true
      },
      data: [],
      table: {
        dates: [],
        users: [],
        workItems: [],
        roles: []
      },
      tabs: {
        currentTabs: [{ name: 'developer', display_name: 'Developer' }],
        tabsList: []
      },
      fullscreen: false,
      showRemote: true,
      showBooking: { value: 'all', label: 'All bookings' },
      employmentType: { value: 'all', label: 'All employment types' },
      paymentType: { value: 'all', label: 'All payment types' },
      getMonth: [],
      users: [],
      projects: []
    }
  },
  directives: {
    dragscroll: dragscroll
  },
  components: {
    BookingForm,
    Filters,
    TableUserItem,
    TextEditor,
    PageHeader,
    Preloader,
    EmptyStateNoResults
  },
  mixins: [BookingMixin],
  async created () {
    if (
      this.$can('read_own-booking_view') &&
      !this.$can('read_all-booking_view')
    ) {
      this.filter.users.push(this._UserInfo)
      this.users.push(this._UserInfo)
    }
  },
  async mounted () {
    await this.$api.projects
      .getProjects()
      .then((data) => {
        this.filters.projects.options = data
        this.projects = data
      })
      .catch(console.error)
    await this.axios
      .post(
        '/api/users',
        {},
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }
      )
      .then((response) => {
        if (response.status === 200) {
          this.filters.users.options = response.data
          this.users = response.data
        }
      })
      .catch(console.error)
    await this.axios
      .post(
        '/api/get-unit-managers',
        {
          unit_managers: []
        },
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }
      )
      .then((response) => {
        if (response.status === 200) {
          this.unitManagers = response.data
          this.filters.unitManagers.options = response.data
          if (Object.keys(this.$route.query).length !== 0) {
            for (let item in this.$route.query) {
              if (item.indexOf('users') !== -1) {
                this.users.forEach((element, index) => {
                  if (element.id === +this.$route.query[item]) {
                    this.filters.users.value.push(element)
                    this.users.push(element)
                  }
                })
              } else if (item.indexOf('unitManagers') !== -1) {
                this.unitManagers.forEach((element, index) => {
                  if (element.id === +this.$route.query[item]) {
                    this.filters.unitManagers.value.push(element)
                  }
                })
              } else if (item.indexOf('projects') !== -1) {
                this.projects.forEach((element, index) => {
                  if (element.id === +this.$route.query[item]) {
                    this.filters.projects.value.push(element)
                    this.projects.push(element)
                  }
                })
              }
            }
          }
        }
      })
      .catch(console.error)
    this.setProjectStatuses()
    this.isAllOptionsFilterSet = true
    await this.drawTable()
    if (this.$can(permissions.ReadAllComments)) {
      await this.fetchComments({ type: commentEntityTypes.WorkScheduleItem })
    }
  },
  beforeDestroy () {
    constants.allMonths = [{ value: 'All months' }]
  },
  computed: {
    isInitialDataLoaded () {
      return this.isAllOptionsFilterSet && this.isBookingDataLoaded
    },
    ...mapGetters({
      dateFormat: 'dateFormat',
      getCurrentUserRole: 'getCurrentUserRole',
      getCurrentUserName: 'getCurrentUserName',
      getCurrentUserId: 'getCurrentUserId',
      projectStatuses: 'getProjectStatuses'
    }),
    commentEntityTypes () {
      return commentEntityTypes
    },
    usersByRole () {
      if (
        !this.tabs.currentTabs.length ||
        this.tabs.currentTabs.some(
          (item) => item.name === constants.allRoles.name
        )
      ) {
        return this.table.users
      }

      let filteredUsers = {}
      for (let [jiraUserName, user] of Object.entries(this.table.users)) {
        if (
          user.roles.some((value) =>
            this.tabs.currentTabs.some((item) => item.name === value)
          )
        ) {
          filteredUsers[jiraUserName] = user
        }
      }

      return filteredUsers
    },
    checkBooking () {
      if (this.showBooking.value === 'all') {
        return this.usersByRole
      }
      const currentUsers = Object.assign({}, this.usersByRole)
      const usersWithBooking = []
      const valArr = Object.values(Object.values(this.table.workItems))
      const someArr = valArr.flatMap((item) => Object.entries(item))
      for (let [key, obj] of someArr) {
        if (obj.hasOwnProperty('items')) {
          usersWithBooking.push(key)
        }
      }
      const uniqUsersWithBooking = uniqBy(usersWithBooking)
      if (this.showBooking.value === 'with-booking') {
        for (let key in currentUsers) {
          if (!uniqUsersWithBooking.includes(key)) {
            delete currentUsers[key]
          }
        }
      } else if (this.showBooking.value === 'no-booking') {
        for (let key in currentUsers) {
          if (uniqUsersWithBooking.includes(key)) {
            delete currentUsers[key]
          }
        }
      }

      return currentUsers
    },
    checkEmploymentType () {
      const currentUsers = Object.assign({}, this.checkBooking)
      if (this.employmentType && this.employmentType.value !== 'all') {
        const currentEmploymetType = this.employmentType.value
        for (let key in currentUsers) {
          if (currentUsers[key].employment_type.type !== currentEmploymetType) {
            delete currentUsers[key]
          }
        }
      }

      return currentUsers
    },
    checkPaymentType () {
      const currentUsers = Object.assign({}, this.checkEmploymentType)

      if (this.paymentType && this.paymentType.value !== 'all') {
        const currentPaymentType = this.paymentType.value
        for (let key in currentUsers) {
          if (currentUsers[key].payment_type !== currentPaymentType) {
            delete currentUsers[key]
          }
        }
      }
      return currentUsers || {}
    },
    getUsers () {
      return this.checkPaymentType || {}
    },
    getAllMonth () {
      if (!this.table.workItems) {
        return []
      }
      if (constants.allMonths.length === 1) {
        const workItemsKeys = Object.keys(this.table.workItems)
        const monthsData = new Set(
          workItemsKeys.map((item) => item.split('-')[1])
        )

        for (const month of monthsData) {
          constants.allMonths.push({ value: month })
        }

        this.getFirstMonth(constants.allMonths)
      }

      return constants.allMonths || []
    },
    getDates () {
      const datesObj = this.table.dates
      for (const i in this.getMonth) {
        if (this.getMonth[i].value === 'All months') {
          return datesObj
        }
      }

      return Object.keys(datesObj)
        .filter(
          (key) =>
            this.getMonth
              .map((object) => object.value)
              .indexOf(key.split('-')[1]) > -1
        )
        .reduce((cur, key) => {
          return Object.assign(cur, { [key]: datesObj[key] })
        }, {})
    }
  },
  methods: {
    ...mapActions({
      fetchComments: 'comments/fetchComments'
    }),
    getBookingStyle (workItem) {
      const width = this.setWorkingItemDuration(workItem.duration)
      const style = {
        width: width,
        backgroundColor: workItem.color ? workItem.color : '#318ea0',
        justifyContent: parseInt(width, 10) >= 149 ? 'center' : 'normal'
      }
      return style
    },
    getBacklogStyle (workItem) {
      const width = this.getBacklogDuration(workItem.duration)
      const style = {
        width: width,
        backgroundColor: workItem.color,
        justifyContent: parseInt(width, 10) >= 149 ? 'center' : 'normal'
      }
      return style
    },
    removeTask (task) {
      this.formLoading = true

      this.$api.booking.removeBooking(task.id)
        .then((data) => {
          if (data) {
            this.successNotifications('Booking removed successfully')

            this.drawTable()
            this.editedItem = {}
            this.$refs['bookingModal'].hide()
            this.dialog = false
            this.loading = true
          } else {
            this.errorNotifications('Booking was not removed')
          }
        })
        .catch((error) => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.formLoading = false
        })
    },
    showRemoteTasks (date, jiraUserName) {
      const isTaskRemote = ['rx'].includes(
        this.table.workItems[date][jiraUserName].working_day_type
      )

      if (!isTaskRemote) return true

      return this.showRemote
    },
    selectRole (event) {
      this.$refs.multiselect.toggle()

      if (event.name === constants.allRoles.name) {
        this.tabs.currentTabs = [constants.allRoles]
        return
      }

      if (event.name !== constants.allRoles.name) {
        let fcTabs = {
          addRole: () => {
            this.tabs.currentTabs.push(event)
            this.tabs.currentTabs = this.tabs.currentTabs.filter(
              (item) => item.name !== constants.allRoles.name
            )
          },
          removeRole: () => {
            if (this.tabs.currentTabs.length === 1) {
              this.tabs.currentTabs = [constants.allRoles]
              return
            }

            this.tabs.currentTabs = this.tabs.currentTabs.filter(
              (item) => item.name !== event.name
            )
          }
        }

        const isSelected = this.tabs.currentTabs.some(
          (item) => item.name === event.name
        )
        const status = isSelected ? 'removeRole' : 'addRole'
        fcTabs[status]()
      }
    },
    selectMonths (event) {
      this.$refs.months.toggle()

      if (event.value === constants.allMonths[0].value) {
        this.getMonth = constants.allMonths
        return
      }

      if (event.value !== constants.allMonths[0].value) {
        let cMonth = {
          addMonth: () => {
            this.getMonth.push(event)
            this.getMonth = this.getMonth.filter(
              (item) => item.value !== constants.allMonths.value
            )
          },
          removeMonth: () => {
            if (this.getMonth.length === 1) {
              this.getMonth = constants.allMonths
              return
            }

            this.getMonth = this.getMonth.filter(
              (item) => item.value !== event.value
            )
          }
        }

        const isSelected = this.getMonth.some(
          (item) => item.value === event.value
        )
        const status = isSelected ? 'removeMonth' : 'addMonth'
        cMonth[status]()
      }
    },
    toggleFullscreen () {
      this.$refs['fullscreen'].toggle()
    },
    fullScreenChange (fullscreen) {
      this.fullscreen = fullscreen
    },
    setProjectStatuses () {
      this.filters.projectStatus.options = ['All', ...this.projectStatuses]
    },
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    async clearCache () {
      this.$api.base
        .clearBookingCache()
        .then((data) => {
          if (data) {
            this.$snotify.success(
              'Cache flushed successfully',
              'Success',
              this.$store.state.snotify
            )
          }
        })
        .catch((error) => {
          this.$snotify.error(
            error.response.data.message,
            'Error',
            this.$store.state.snotify
          )
        })
    },
    prepareDataForGetReports (fields) {
      let data = {}

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (name === 'project_status' && value === 'All') {
          value = null
        }
        if (Array.isArray(value)) {
          value = value.map((item) => item[fields[key]['valueField']])
        }

        data[name] = value
      }
      return data
    },
    drawTableByFilters (fields) {
      this.selectedFilters = fields
      this.drawTable()
    },
    drawTable () {
      this.showNoData = false
      this.loading = true
      this.getUsersDaysInfo()
    },
    getUsersDaysInfo () {
      const payload = this.prepareDataForGetReports(this.selectedFilters)

      this.$api.booking
        .getWorkSchedule(payload)
        .then((data) => {
          this.tabs.tabsList = [constants.allRoles, ...this._allUserRoles]
          this.table.users = data.users
          this.table.dates = data.scheduleTimeLine
          this.table.workItems = data.workItems
          this.isBookingDataLoaded = true
        })
        .catch((error) => {
          if (error.response) {
            this.errorNotifications(error)
          } else {
            throw error
          }
          this.showNoData = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    createUserTooltip (user) {
      let message = user.totalRemainingEstimate
        ? 'Work schedule for ' + user.totalRemainingEstimate
        : ''
      message = message || 'No tasks in work schedule'
      message = `${user.name || ''} <br/> ${user.position || ''} <br/> ${
        user.employment_type.label || ''
      }/${user.payment_type || ''} <br/> ${message}`
      return `<div class="text-left" style="font-size: 12px;">${message}</div>`
    },
    createTaskTooltip (description) {
      return `<div class="text-left" style="font-size: 12px;">
                  ${description}
              </<div>`
    },
    getBacklogDuration (durationSeconds) {
      const backlogPercent = durationSeconds / 3600 / constants.fullDayHours
      return constants.tdWidthWithoutBorder * backlogPercent + 'px'
    },
    hasBookingOnThisDate (bookings, date) {
      return bookings.some((item) => item.startLine === date)
    },
    editModalOpen (data) {
      if (
        !this.$can('update_all-booking_view') &&
        !this.$can('update_all-booking_management')
      ) {
        return
      }
      this.dialog = true
      this.isEdit = true

      this.editedItem = {
        id: data.id,
        booking_type_id: data.booking_type_id,
        start_date: data.start_date,
        end_date: data.end_date,
        user_id: data.user.id,
        hours_per_day: data.hours_per_day,
        booking_hours: data.booking_hours,
        project_id: data.project_id,
        comment: data.comment
      }

      this.$refs['bookingModal'].show()
    },
    create (data) {
      this.formLoading = true
      this.$api.booking
        .create(data)
        .then((data) => {
          if (data.success) {
            this.successNotifications('Booking created successfully')
            this.drawTable()
            this.editedItem = {}
            this.$refs['bookingModal'].hide()
            this.dialog = false
            this.loading = true
          } else {
            this.errorNotifications('Booking was not created')
          }
        })
        .catch((error) => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.formLoading = false
        })
    },
    addBooking ({ user, date }) {
      this.editedItem = {
        user_id: user.id,
        hours_per_day: 8,
        start_date: date,
        end_date: date,
        booking_type_id: 2
      }

      this.dialog = true
      this.isEdit = false
      this.$refs['bookingModal'].show()
    },
    edit (data) {
      this.formLoading = true
      this.$api.booking
        .edit(this.editedItem.id, data)
        .then((data) => {
          if (data.success) {
            this.successNotifications('Booking edited successfully')
            this.drawTable()
            this.editedItem = {}
            this.$refs['bookingModal'].hide()
            this.dialog = false
            this.loading = true
          } else {
            this.errorNotifications('Booking was not edited')
          }
        })
        .catch((error) => {
          this.errorNotifications(error)
        })
        .catch((error) => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.formLoading = false
        })
    },
    setBookingLineTop (index, dayOffs, backlog) {
      let increment = Number(!!dayOffs) + Number(!!backlog)
      return (index + increment) * 23 + 2 + 'px'
    },
    setVacationLineTop (backlog) {
      let increment = Number(!!backlog)
      return increment * 23 + 2 + 'px'
    },
    setWorkingItemDuration (durationSeconds, decreaseFor = 0) {
      if (
        typeof durationSeconds === 'undefined' ||
        durationSeconds === undefined
      ) {
        durationSeconds = 3600 * 8
      }
      return (
        constants.tdWidth * (durationSeconds / (3600 * 8)) -
        1 -
        decreaseFor +
        'px'
      )
    },
    redirectToBacklogPage (user) {
      let routeData = this.$router.resolve({
        path: '/backlog-time-report',
        query: {
          userId: user.id
        }
      })
      window.open(routeData.href, '_blank')
    },
    fixRoleName (name) {
      if (name.toLowerCase() === 'qa') {
        return name.toUpperCase()
      }
      let arrayOfStrings = name.split('_')
      return arrayOfStrings.join(' ')
    },
    submit (data) {
      if (this.isEdit) {
        this.edit(data)
        return
      }
      this.create(data)
    },
    getFirstMonth (months) {
      this.getMonth = this.getMonth.concat([months[1], months[2]])
    },
    handleResetFilters () {
      // Reset all filter values to their defaults
      this.selectedFilters = {}
      this.drawTable()
    }
  }
}
</script>

<style scoped lang="scss">
.col-md-3 {
  z-index: 10;
}

.table-wrapper {
  padding-top: 20px;

  h3 {
    margin-bottom: 0;
  }
}

.table-wrapper-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 50px;

  .btn {
    cursor: pointer;
  }
}

.booking-table-wrapper {
  position: relative;

  .table {
    min-height: 177px;
  }
}

/* Loading overlay for booking table and controls */
.table__theme-default.loading-data {
  position: relative;
}

.table__theme-default.loading-data::before {
  content: '';
 position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $tableModalBgOverlay;
  border-radius: 10px;
  z-index: 13;
  pointer-events: all;
}

.table__theme-default.loading-data::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 37px;
  height: 37px;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: booking-spinner 0.75s linear infinite;
  color: $sinnerColor;
  z-index: 15;
}

@keyframes booking-spinner {
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.table {
  background-color: #fff;
  overflow: hidden;
  position: static;

  tr {
    display: flex;
  }

  .first-date-in-head {
    margin-left: 235px;
  }

  thead {
    td {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  }

  tbody {
    tr {
      padding-left: 230px;
    }
  }

  th,
  td {
    width: 150px;
    padding: 10px 5px;
  }

  td {
    height: 60px;
    max-height: 60px;
    overflow: hidden;
    position: relative;
    border: 0;
    white-space: nowrap;

    &.fixed-td {
      z-index: 9;
      left: 0;
      padding: 12px 10px 10px 2px;
      height: 60px;
      max-height: 60px;
    }

    .remote-day {
      width: 100%;
      z-index: 10;
      position: absolute;
      border: 2px dashed #4cfbff;
      left: 0;
      top: 0;
    }

    &.fixed-user {
      width: 170px;
      max-width: 170px;
    }

    &.fixed-comment {
      width: 20px;
      text-align: center;
    }

    &.fixed-number {
      width: 20px;
      max-width: 20px;
    }
  }

  th {
    text-align: center;

    &.fixed-user {
      width: 155px;
      text-align: left;
    }

    &.fixed-actions {
      width: 35px;
    }

    &.fixed-number {
      width: 20px;
    }
  }

  .day__add {
    width: 100%;
    height: 100%;
    display: flex;
    left: 0;
    top: 0;
    font-size: 12px;
    line-height: 0;
    z-index: 1;

    &:hover {
      background-color: #eee;
      color: #7489a9;
    }
  }

  .day__add-link {
    background: #e4e7ee;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: #7489a9;
    height: 100%;
    border-radius: 2px;
    text-transform: uppercase;
  }
}

.table-scroll {
  overflow-x: scroll;
  max-width: 100%;
  cursor: -webkit-grab;
  cursor: -moz-grab;
  cursor: -o-grab;
  cursor: grab;

  &:active {
    cursor: -webkit-grabbing;
    cursor: -moz-grabbing;
    cursor: -o-grabbing;
    cursor: grabbing;
  }
}

.fixed-td {
  position: absolute !important;
  overflow: hidden;
  white-space: nowrap;
  font-size: 15px;
  padding-left: 2px;
  padding-right: 10px;
  left: 0;
  background-color: #fff;
  z-index: 5;
  border-top: 0;
  border-right: 0;
  cursor: pointer;

  th {
    &:hover {
      background-color: rgb(235, 230, 230);
    }
  }
}

.spinner-border {
  border-width: 0.25rem !important;
}

.filter-buttons {
  padding-top: 34px;
}

.table-fullscreen-container {
  margin-top: 30px;
}

.booking-line {
  font-family: $font-family-sans-serif;
  font-weight: 700;
  top: 0;
  text-align: center;
  height: 100%;
  left: 1px;
  background-color: rgb(49, 142, 160);
  color: #fff;
  padding: 2px;
  font-size: 11px;
  border-radius: 3px;
  cursor: pointer;
  z-index: 2;
  opacity: 0.8;
  position: relative;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none !important;
  line-height: 30px;
  margin-right: 2px;

  &:hover {
    opacity: 1;
  }

  &:last-child {
    margin-right: 0;
  }
}

.booking-line_dayoff {
  cursor: auto;
  font-size: 15px;

  &.booking-line-s,
  &.booking-line-ns {
    background-color: #9628ac;
  }

  &.booking-line-v,
  &.booking-line-nv {
    background-color: #2ebe52;
  }
}

.filter__button {
  &::first-letter {
    text-transform: uppercase;
  }

  &.active {
    background-color: #2ebe52;
  }
}

.tabs .btn {
  font-size: 14px;
}

th.scheduleTimeLine {
  font-size: 11px;
}

/*.table {
  td.fixed-td {
    z-index: 9;
    left: 0;
  }
  td.fixed-user {
    width: 200px !important;
    min-width: auto !important;
  }

  td.fixed-number {
    width: 20px !important;
    min-width: auto !important;
  }
  th.fixed-user {
    width: 155px !important;
    min-width: auto !important;
  }

  th.fixed-actions {
    width: 35px !important;
    min-width: auto !important;
  }

  th.fixed-number {
    width: 20px !important;
    min-width: auto !important;
  }
}*/

// .booking-user-name {
//   font-size: 13px;
//   color: $tableTextHeadColor2;
//   margin-bottom: 2px;
//   text-overflow: ellipsis;
//   overflow: hidden;
// }
// .booking-user-position {
//   font-size: 11px;
//   color: $tableTextHeadColor;
//   text-overflow: ellipsis;
//   overflow: hidden;
// }

.booking-day-off {
  background: #e4e7ee;
  border-radius: 2px;
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: $tableTextHeadColor;
  align-items: center;
  justify-content: center;
  display: flex;
  text-transform: uppercase;
}

.booking-works-event {
  display: flex;
  padding: 5px 0;
  background-color: #e4e6ee;
  color: black;
  height: 100%;
  width: 100%;
  border-radius: 2px;
}

.booking-works-event .booking-line {
  color: black;
}

.table .day__add-link.full-time-team-members {
  background: #ffe6de;
}

.table-info-label {
  display: flex;
  font-weight: 500;
  padding: 7px 10px;
  background: $tableTextHeadColor4;
  border-radius: 2px;
  align-items: center;
  justify-content: center;
  color: $tableTextHeadColor;
  font-size: 12px;
}

.bg-stripes {
  background-image: linear-gradient(
    135deg,
    #dadcdc 25%,
    #f3f5f7 25%,
    #f3f5f7 50%,
    #dadcdc 50%,
    #dadcdc 75%,
    #f3f5f7 75%,
    #f3f5f7 100%
  ) !important;
  background-size: 5px 5px !important;
}

.table-control {
  display: flex;
  align-items: center;
}

.table-control__text {
  font-size: 13px;
  color: $tableTextHeadColor2;
  margin-left: 5px;
  cursor: pointer;
}

.booking-input {
  width: 150px;
}

.big-input {
  width: 173px;
}

.switch {
  background-color: transparent !important;
  border: none;
}

</style>
